import script from "./header-phone.vue?vue&type=script&setup=true&lang=js"
export * from "./header-phone.vue?vue&type=script&setup=true&lang=js"

import "./header-phone.vue?vue&type=style&index=0&id=7e780b4e&lang=less"

const __exports__ = script;

export default __exports__